<template>
  <div class="max-w-lg w-full mx-auto" data-testid="registration-finished">
    <div class="w-full bg-gray-200 rounded-full h-1.5 absolute top-0 left-0" v-if="isMultiStep">
            <div class="bg-blue-500 h-1.5  w-full"></div>
    </div>
   
    <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0">
      <div class="mt-16 mx-auto max-w-7xl px-4 sm:mt-20 sm:px-6">
      <div class="flex items-center justify-center mb-3">
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M16.0002 28.8002C23.0694 28.8002 28.8002 23.0694 28.8002 16.0002C28.8002 8.93095 23.0694 3.2002 16.0002 3.2002C8.93095 3.2002 3.2002 8.93095 3.2002 16.0002C3.2002 23.0694 8.93095 28.8002 16.0002 28.8002ZM21.9316 13.9316C22.5564 13.3067 22.5564 12.2937 21.9316 11.6688C21.3067 11.044 20.2937 11.044 19.6688 11.6688L14.4002 16.9375L12.3316 14.8688C11.7067 14.244 10.6937 14.244 10.0688 14.8688C9.44399 15.4937 9.44399 16.5067 10.0688 17.1316L13.2688 20.3316C13.8937 20.9564 14.9067 20.9564 15.5316 20.3316L21.9316 13.9316Z" fill="#22C55E"/>
      </svg>
      </div>
        <div class="text-center">
          <h1
            class="text-3xl tracking-tight font-black text-primary"
          >
            <span class="block">That's it {{ name }},</span>
            <span class="block">we're all set!</span>
          </h1>
          <p
            class="mt-4 max-w-sm mx-auto font-extrabold text-primary md:mt-5 text-lg"
          >
            Thank you for registering for your Personalised GraduationClip.
          </p>
          <p class="mt-2 max-w-sm mx-auto font-extrabold text-primary text-lg">
          You will receive further information by email after your ceremony.
          </p>
          <p class="text-base font-medium text-secondary mt-6 mb-4">
          Here's your registration number is:
          </p>
           <p
            class="mb-4 max-w-sm mx-auto text-blue-500 text-lg sm:text-xl"
            data-testid="registration-id"
          >
             <b>{{registrationID}}</b> 
          </p> 
          <p class="font-medium text-base text-secondary">Please take note of this in case you need to contact us.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Finished",
  props: { name: String, registrationID : String },
  computed: {
        isMultiStep() {
            return process.env.VUE_APP_FORM_MODE === "multi";
        }
    },
};
</script>
